import * as React from "react";
function SvgIconEmail(props) {
  return <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="#fff" strokeWidth={1.5}><rect x={2} y={3} width={16} height={14} rx={2.25} /><path d="M2.242 4.207l6.013 4.49a2.92 2.92 0 003.49 0l6.013-4.49" /></g></svg>;
}
export default SvgIconEmail;